import { Card, SubTitle, Title } from "components/atoms";
import { Template } from "components/modecules";
import { Link } from "react-router-dom";

export default function RulesPage() {
  return (
    <Template>
      <div className="w-full bg-primary rounded-[20px] shadow-md px-8 md:px-16 py-10 transition-all duration-300 ease-in-out max-w-[1080px] m-auto mt-10 font-futura-book">
        <Link to="/" className="underline">
          Revenir à l'accueil
        </Link>
        <h2 className="font-tt-ramillas-trl-bold-italic text-center text-[25px] text-fourth uppercase mt-8 mb-5">
          Règlement du jeu-concours "Quiz handicap"
        </h2>

        <SubTitle>Article 1 - Société organisatrice</SubTitle>
        <p>
          Yumaincap, entreprise adaptée spécialisée en conseils RH et politique
          handicap, organise un jeu en ligne pour les salariés de Balzac. Le jeu
          se tiendra à partir du{" "}
          <span className="font-bold">
            14 janvier 2025 et s'étendra sur une durée de deux semaines.
          </span>
        </p>

        <SubTitle>Article 2 - Objet du jeu</SubTitle>
        <p>
          Ce jeu est gratuit et sans obligation d'achat. Il se déroule
          exclusivement sur Internet. Les participants répondront en ligne à un
          questionnaire de 21 (vingt-et-une) questions.
        </p>
        <SubTitle>Article 3 - Description du jeu</SubTitle>
        <p>Pour participer à ce jeu, les salariés doivent :</p>
        <br />
        <ol>
          <li>1. Être une personne physique et majeure</li>
          <li>
            2. Accéder au lien fourni dans les mails de communication ou scanner
            le QR code figurant sur les supports de communication.
          </li>
          <li>
            3. Répondre à chacune des questions en cochant, parmi les réponses
            proposées, la réponse estimée exacte, puis valider sa participation.
            Chaque questionnaire doit être complet pour valider la participation
          </li>
          <li>4. Une seule participation est autorisée par personne.</li>
        </ol>

        <SubTitle>Article 4 - Conditions de participation</SubTitle>
        <p>
          <b>4.1</b> Toute participation ne respectant pas les règles fixées à
          l'article 3, toute multi-participation ou toute participation hors des
          dates d'organisation du jeu sera considérée comme nulle et ne sera pas
          prise en compte.
          <br />
          <br />
          L'utilisation de robots ou de tout autre procédé similaire permettant
          de participer de manière mécanique ou automatisée est strictement
          interdite. Toute violation de cette règle entraînera l'élimination
          définitive du participant concerné.
        </p>
        <br />
        <p>
          <b>4.2</b> La société organisatrice se rés erve le droit, en cas de
          force majeure, de modifier, suspendre, prolonger ou annuler le jeu.
        </p>
        <br />
        <p>
          <b>4.3</b> La responsabilité de la société organisatrice ne pourra
          être engagée en cas de destruction totale ou partielle des
          informations relatives à la participation, suite à des incidents
          techniques, des défaillances des réseaux ou tout autre événement de
          force majeure qui pourrait empêcher la bonne organisation du jeu.
        </p>

        <SubTitle>Article 5 - Acceptation du règlement</SubTitle>
        <p>
          La participation au jeu implique l'acceptation, sans réserve ni
          condition, du présent règlement.
        </p>
        <SubTitle>Article 6 - Dépôt du règlement</SubTitle>
        <p>
          Le règlement du jeu est disponible en intégralité pendant toute la
          durée de l'événement.
        </p>
        <SubTitle>Article 7 - Litiges</SubTitle>
        <p>
          Tout litige relatif à l'interprétation ou à l'application du présent
          règlement sera soumis aux tribunaux compétents, même en cas de
          pluralité de défendeurs ou de référé.
        </p>

        <br />
        <br />
        <p className="text-right">
          Fait à Evry - Courcouronnes, le 20 décembre 2024.
        </p>
      </div>
    </Template>
  );
}
